module.exports = __webpack_public_path__ + "img/keyboard_Q.8a9ab5a0.png";